var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStepperUserIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/user-add"
  }, /*#__PURE__*/React.createElement("g", {
    id: "user-add"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.99967 9.99984C12.3009 9.99984 14.1663 8.13436 14.1663 5.83317C14.1663 3.53198 12.3009 1.6665 9.99967 1.6665C7.69849 1.6665 5.83301 3.53198 5.83301 5.83317C5.83301 8.13436 7.69849 9.99984 9.99967 9.99984Z",
    stroke: "#0C80F3",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M2.8418 18.3333C2.8418 15.1083 6.05013 12.5 10.0001 12.5C10.8001 12.5 11.5751 12.6083 12.3001 12.8083",
    stroke: "#0C80F3",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M18.3337 14.9998C18.3337 15.2665 18.3003 15.5248 18.2337 15.7748C18.1587 16.1082 18.0253 16.4332 17.8503 16.7165C17.2753 17.6832 16.217 18.3332 15.0003 18.3332C14.142 18.3332 13.367 18.0081 12.7837 17.4748C12.5337 17.2581 12.317 16.9998 12.1503 16.7165C11.842 16.2165 11.667 15.6248 11.667 14.9998C11.667 14.0998 12.0253 13.2749 12.6087 12.6749C13.217 12.0499 14.067 11.6665 15.0003 11.6665C15.9837 11.6665 16.8753 12.0915 17.4753 12.7749C18.0087 13.3665 18.3337 14.1498 18.3337 14.9998Z",
    stroke: "#0C80F3",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M16.2411 14.9834H13.7578",
    stroke: "#0C80F3",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M15 13.7666V16.2583",
    stroke: "#0C80F3",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStepperUserIcon);
export default __webpack_public_path__ + "static/media/stepper-user-icon.fd5a63b3dede4504e8fa940aa436e08e.svg";
export { ForwardRef as ReactComponent };